module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-chooser"
    }
  }, [_c('v-btn', {
    staticClass: "font-weight-bold blew--text",
    attrs: {
      "block": "",
      "depressed": "",
      "color": "#E3F2FD",
      "id": "tryout_chooser_tambah_kelas"
    },
    on: {
      "click": function($event) {
        return _vm.newInitData()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px !important"
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n        Tambah Kelas\n    ")], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "940px",
      "min-height": "537px",
      "max-height": "771px"
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-text', {
          attrs: {
            "width": "100%"
          }
        }, [_c('app-datatable', {
          attrs: {
            "items": _vm.rows,
            "headers": _vm.headers,
            "hasAction": false,
            "has-custom-pagination": false,
            "custom-pagination-current-page": 1,
            "custom-pagination-per-page": 10,
            "has-custom-search": false
          },
          on: {
            "dblClicked": function($event) {
              return _vm.tryoutSelected($event)
            },
            "selected": function($event) {
              _vm.selectedRow = $event
            }
          }
        })], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "text-h2"
        })]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "justify-end"
        }, [_c('v-btn', {
          attrs: {
            "text": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_vm._v("Close")])], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67943e70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/JadwalKelasChooser.vue
// module id = 1696
// module chunks = 1